var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.startVipCount || _vm.timeStr != '' )?_c('div',{staticClass:"com-vip-newyear-button-box",on:{"click":_vm.clickVipButton}},[_c('div',{staticClass:"com-vip-ny-btn-text"},[_vm._v(_vm._s(_vm.timeStr))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }